import { z } from 'zod';
/** Search DSL accepted by POST /v1/projects/:id/search (mapped to OpenSearch). */
export const sessionSearchSchema = z.object({
    email: z.string().optional(),
    userId: z.string().optional(),
    anonymousId: z.string().optional(),
    sessionId: z.string().optional(),
    browser: z.string().optional(),
    os: z.string().optional(),
    country: z.string().optional(),
    city: z.string().optional(),
    url: z.string().optional(),
    minDurationMs: z.number().int().nonnegative().optional(),
    maxDurationMs: z.number().int().nonnegative().optional(),
    hasError: z.boolean().optional(),
    hasRageClick: z.boolean().optional(),
    hasDeadClick: z.boolean().optional(),
    hasConsoleError: z.boolean().optional(),
    /** Omit known crawler / bot sessions from the results. */
    excludeBots: z.boolean().optional(),
    featureFlag: z.string().optional(),
    customEvent: z.string().optional(),
    from: z.string().datetime().optional(),
    to: z.string().datetime().optional(),
    limit: z.number().int().min(1).max(200).default(50),
    offset: z.number().int().min(0).default(0),
});
//# sourceMappingURL=session.js.map